import { WebApiService } from '../../../plugins/webApiService'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import UpdateQueueTaskEmployeeRoleListRequest from '../../../projects/performers/i-service/model/queue-task/request/UpdateQueueTaskEmployeeRoleListRequest';
import UpdateQueueTaskEmployeeRoleAccessListRequest from '../../../projects/performers/i-service/model/queue-task/request/UpdateQueueTaskEmployeeRoleAccessListRequest';
import GetQueueTaskEmployeeListRequest from '../../../projects/performers/i-service/model/queue-task/request/GetQueueTaskEmployeeListRequest';
import GetQueueTaskEmployeeListDetailRequest from '../../../projects/performers/i-service/model/queue-task/request/GetQueueTaskEmployeeListDetailRequest';
import GetQueueTaskRemovedEmployeeListRequest from '../../../projects/performers/i-service/model/queue-task/request/GetQueueTaskRemovedEmployeeListRequest';
import GetAccessCurrentUserInQueueTaskByIdRequest from '../../../projects/performers/i-service/model/queue-task/request/GetAccessCurrentUserInQueueTaskByIdRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import GetQueueTaskEmployeeListResponse from '../../../projects/performers/i-service/model/queue-task/response/GetQueueTaskEmployeeListResponse';
import GetQueueTaskEmployeeListDetailResponse from '../../../projects/performers/i-service/model/queue-task/response/GetQueueTaskEmployeeListDetailResponse';
import GetQueueTaskRemovedEmployeeListResponse from '../../../projects/performers/i-service/model/queue-task/response/GetQueueTaskRemovedEmployeeListResponse';
import GetAccessCurrentUserInQueueTaskByIdResponse from '../../../projects/performers/i-service/model/queue-task/response/GetAccessCurrentUserInQueueTaskByIdResponse';

/**
 * * Сервис для назначения доступа пользователям к очередям
 */
export default class QueueTaskAdminRoleService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	
	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
	}

	/**
	 * * Обновление ролей админа
	 */
	async UpdateQueueTaskEmployeeRoleList(request: UpdateQueueTaskEmployeeRoleListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'QueueTaskAdminRoleService',
			Method: 'UpdateQueueTaskEmployeeRoleList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновить права пользователя с доступом к очереди задач
	 */
	async UpdateQueueTaskEmployeeRoleAccessList(request: UpdateQueueTaskEmployeeRoleAccessListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'QueueTaskAdminRoleService',
			Method: 'UpdateQueueTaskEmployeeRoleAccessList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список сотрудников с доступами к очереди задач
	 */
	async GetQueueTaskEmployeeList(request: GetQueueTaskEmployeeListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'QueueTaskAdminRoleService',
			Method: 'GetQueueTaskEmployeeList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение детальной информации о списке сотрудников рабочей области с доступами по очереди задач
	 */
	async GetQueueTaskEmployeeListDetail(request: GetQueueTaskEmployeeListDetailRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'QueueTaskAdminRoleService',
			Method: 'GetQueueTaskEmployeeListDetail',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка сотрудников удаленных из доступов очереди и потерявших доступ к созданным задачам
	 */
	async GetQueueTaskRemovedEmployeeList(request: GetQueueTaskRemovedEmployeeListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'QueueTaskAdminRoleService',
			Method: 'GetQueueTaskRemovedEmployeeList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение доступов по текущему пользователю в очереди задач по идентификатору
	 */
	async GetAccessCurrentUserInQueueTaskById(request: GetAccessCurrentUserInQueueTaskByIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'QueueTaskAdminRoleService',
			Method: 'GetAccessCurrentUserInQueueTaskById',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Обновление ролей админа
	 */
	async updateQueueTaskEmployeeRoleListAsync(request: UpdateQueueTaskEmployeeRoleListRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'QueueTaskAdminRoleService',
				Method: 'UpdateQueueTaskEmployeeRoleList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновить права пользователя с доступом к очереди задач
	 */
	async updateQueueTaskEmployeeRoleAccessListAsync(request: UpdateQueueTaskEmployeeRoleAccessListRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'QueueTaskAdminRoleService',
				Method: 'UpdateQueueTaskEmployeeRoleAccessList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список сотрудников с доступами к очереди задач
	 */
	async getQueueTaskEmployeeListAsync(request: GetQueueTaskEmployeeListRequest): Promise<GetQueueTaskEmployeeListResponse> {
		return new Promise<GetQueueTaskEmployeeListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'QueueTaskAdminRoleService',
				Method: 'GetQueueTaskEmployeeList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetQueueTaskEmployeeListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetQueueTaskEmployeeListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение детальной информации о списке сотрудников рабочей области с доступами по очереди задач
	 */
	async getQueueTaskEmployeeListDetailAsync(request: GetQueueTaskEmployeeListDetailRequest): Promise<GetQueueTaskEmployeeListDetailResponse> {
		return new Promise<GetQueueTaskEmployeeListDetailResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'QueueTaskAdminRoleService',
				Method: 'GetQueueTaskEmployeeListDetail',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetQueueTaskEmployeeListDetailResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetQueueTaskEmployeeListDetailResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка сотрудников удаленных из доступов очереди и потерявших доступ к созданным задачам
	 */
	async getQueueTaskRemovedEmployeeListAsync(request: GetQueueTaskRemovedEmployeeListRequest): Promise<GetQueueTaskRemovedEmployeeListResponse> {
		return new Promise<GetQueueTaskRemovedEmployeeListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'QueueTaskAdminRoleService',
				Method: 'GetQueueTaskRemovedEmployeeList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetQueueTaskRemovedEmployeeListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetQueueTaskRemovedEmployeeListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение доступов по текущему пользователю в очереди задач по идентификатору
	 */
	async getAccessCurrentUserInQueueTaskByIdAsync(request: GetAccessCurrentUserInQueueTaskByIdRequest): Promise<GetAccessCurrentUserInQueueTaskByIdResponse> {
		return new Promise<GetAccessCurrentUserInQueueTaskByIdResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'QueueTaskAdminRoleService',
				Method: 'GetAccessCurrentUserInQueueTaskById',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetAccessCurrentUserInQueueTaskByIdResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetAccessCurrentUserInQueueTaskByIdResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}